import Http from '@/utils/httpRequest'

const axios = new Http()
export default {
    getMyProject: data => {
        // 项目公示-查询列表
        return axios.post('/onlineServiceProject/public/getMyProject', data)
    },
    getProjectSchedule: data => {
        // 项目公示-查询详情
        return axios.post('/onlineServiceProject/public/getProjectSchedule', data)
    },
}